import React from "react";
import { useBnbSelector } from "../../../redux/store";
import * as Type from "../../../../../../common-deprecated/styles/v2/lexus/globals/Type";
import { BnbLabel, useBnbOptionalLabel } from "../../../utils/labels";
import * as Flex from "../../../../../../common-deprecated/styles/v2/lexus/globals/Flex";
import Container from "../../../../../../common-deprecated/styles/v2/lexus/globals/Container";
import DisclaimerContainer from "../common/disclaimer/DisclaimerContainer";
import FinanceToggle from "../common/FinanceToggle";
import { isRTL } from "../../../../../../common-deprecated/settings/utils/commonSettingUtils";
import SubModelItem from "./SubModelItem";

const SubModelOverview = (): JSX.Element => {
    const model = useBnbSelector((state) => state.model);
    const submodels = useBnbSelector((state) => state.submodels.list);
    const commonSettings = useBnbSelector((state) => state.commonSettings);
    const availablePromotions = useBnbSelector((state) => state.items.promotions);
    const genericPriceDisclaimerSubmodel = useBnbOptionalLabel("genericPriceDisclaimerSubmodel");

    return (
        <Container my={{ _: 5, lg: "60px" }}>
            <Flex.Row mb={5}>
                <Flex.Col width={{ xs: 1, md: 1 / 2, lg: 8 / 12 }} textAlign={isRTL(commonSettings) ? "right" : "left"}>
                    <Type.H1 headingType="gamma" mb={0}>
                        <BnbLabel label="selectSubmodel" />
                    </Type.H1>
                </Flex.Col>

                <Flex.Col
                    display="flex"
                    justifyContent="flex-end"
                    width={{ xs: 1, md: 1 / 2, lg: 4 / 12 }}
                    textAlign={{ xs: "left", md: "right" }}
                    px={{ md: 3 }}
                    pt={{ xs: 3, md: 0 }}
                >
                    <FinanceToggle modelCode={model.internalCode} />
                </Flex.Col>
            </Flex.Row>

            <Flex.Row alignItems="stretch">
                {submodels.map((submodel) => (
                    <SubModelItem
                        key={submodel.id}
                        submodel={submodel}
                        model={model}
                        availablePromotions={availablePromotions}
                        genericPriceDisclaimerSubmodel={genericPriceDisclaimerSubmodel}
                        commonSettings={commonSettings}
                    />
                ))}
            </Flex.Row>
            <DisclaimerContainer showGenericFinanceDisclaimer hasDarkBackground />
        </Container>
    );
};

export default SubModelOverview;
